import * as dateHelper from '../../utils/date.js';

const minFrDatePivotDays = parseInt(process.env.VUE_APP_ABS_MIN_FROM_DATE_PIVOT_DAYS);
const absMinFrDate = new Date(process.env.VUE_APP_ABS_MIN_FROM_DATE);
const minFrDatePivot = dateHelper.addDays(new Date(Date.now()), minFrDatePivotDays);

const minNights = parseInt(process.env.VUE_APP_MIN_NIGHTS);
const maxNights = parseInt(process.env.VUE_APP_MAX_NIGHTS);

const minFrDate = absMinFrDate > minFrDatePivot ? absMinFrDate : minFrDatePivot;
const nextYear = minFrDate.getFullYear() + 1;
const maxFrDate = new Date(`${nextYear}-12-31`);

const state = { 
    selectedCounty: { countyId: 0, name: 'Co. Donegal' },  // for now hard code the county to Donegal
    fromDate: minFrDate,
    noOfNights: minNights
};

const getters = {
    minFromDate() { return minFrDate },
    maxFromDate() { return maxFrDate },
    minFromDateISOString() { return dateHelper.toISODateString(minFrDate); },
    maxFromDateISOString() { return dateHelper.toISODateString(maxFrDate); },
    minNights() { return minNights; },
    maxNights() { return maxNights; },
    noOfDays(state) {
        if (state.fromDate == null) {
            return null;
        }
        return state.noOfNights + 1;
    },
    toDate(state) {
        return dateHelper.addDays(state.fromDate, state.noOfNights); 
    }
};

const mutations = { 
    setSelectedCounty: (state, payload) => {
        state.selectedCounty = payload;
    },
    setFromDate: (state, payload) => {
        state.fromDate = payload;
    },
    setNoOfNights: (state, payload) => {
        state.noOfNights = payload;
    },
};

const actions = { 
    setSelectedCounty: ({ state, commit, dispatch }, payload) => { 
        if (state.selectedCounty != payload) {
            commit('setSelectedCounty', payload);
        }
    },
    setFromDate: ({ state, commit, dispatch }, payload) => {
        if (state.fromDate != payload) {
            commit('setFromDate', payload);
        }
    },
    setNoOfNights: ({ state, commit, dispatch }, payload) => {
        if (state.noOfNights != payload) {
            commit('setNoOfNights', payload);
        }
    },
}

export default { 
    state,
    getters,
    mutations,
    actions
};

